export class UserPreSharedKey {
  FullName: string;
  Email: string
  PreSharedKey: string;

  constructor() {
    this.FullName = null;
    this.Email = null;
    this.PreSharedKey = null;
  }
}